import styled from 'styled-components';
import { colors } from 'styleguide';

interface BoxProps {
  dark?: boolean;
  light?: boolean;
  radiusBottom?: boolean;
}

const Box = styled.div<BoxProps>`
  height: 32px;

  font-size: 12px;
  background: white;
  border: 1px solid ${colors('neutral', 3)};
  box-sizing: border-box;

  ${(props: BoxProps) =>
    props.dark &&
    `
      background: ${colors('neutral', 4)};
  `}

  ${(props: BoxProps) =>
    props.light &&
    `
      background: ${colors('neutral', 6)};
  `}

  ${(props: BoxProps) =>
    props.radiusBottom &&
    `
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      overflow: hidden;
  `}

  & + & {
    margin-top: -1px;
  }
`;

export default Box;
